import React from "react";
import PropTypes from "kf-proptypes/widgets";

import "antd/es/checkbox/style/css";
import "./checkbox.override.css";

import { CHECKBOX_SIZES, CHECKBOX_TYPES } from "./constants.js";
import { ReadonlyCheckbox } from "./readonly.jsx";
import { EditableCheckbox } from "./editable.jsx";

export function Checkbox({
  value,
  readOnly,
  className,
  label,
  disabled,
  strike,
  onChange,
  onClick = () => {},
  name,
  size,
  type
}) {
  return readOnly ? (
    <ReadonlyCheckbox
      value={value}
      className={className}
      label={label}
      disabled={disabled}
      strike={strike}
      size={size}
      type={type}
    />
  ) : (
    <EditableCheckbox
      value={value}
      onClick={onClick}
      onChange={onChange}
      className={className}
      label={label}
      name={name}
      disabled={disabled}
      strike={strike}
      size={size}
      type={type}
    />
  );
}

Checkbox.propTypes = {
  /** name for the checkbox */
  name: PropTypes.string,
  /** label for the checkbox */
  label: PropTypes.string,
  /**
   * The callback function that is triggered when user change the value of checkbox
   */
  onChange: PropTypes.func.isRequired,
  /**
   * The callback function that is triggered when user clicks the checkbox or label
   */
  onClick: PropTypes.func,
  /** Specifies a disabled checkbox that cannot be checked */
  disabled: PropTypes.bool,
  /** Specifies if a checkbox is checked or not */
  value: PropTypes.bool.isRequired,
  /** Specifies a checkbox with striked label*/
  strike: PropTypes.bool,
  /** Specifies a readOnly checkbox */
  readOnly: PropTypes.bool,
  /**
   * Custom classname to customize the checkbox
   */
  className: PropTypes.string,
  /** Size of the checkbox (base | medium) */
  size: PropTypes.oneOf(Object.values(CHECKBOX_SIZES)),
  /** Type of the check in the checkbox. */
  type: PropTypes.oneOf(Object.values(CHECKBOX_TYPES))
};

Checkbox.defaultProps = {
  onChange: () => {},
  className: "",
  value: undefined,
  size: CHECKBOX_SIZES.BASE,
  type: CHECKBOX_TYPES.TICK
};

export { CHECKBOX_SIZES, CHECKBOX_TYPES };
